(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/client.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/client.js'); 'use strict';

var trinidad = svs.core;
var common = svs.components.emp_video_player.helpers.common;

var vars = {
  logger: new trinidad.log.Logger('components:empplayer'),
  redBeeHost: svs.components.emp_video_player.data && svs.components.emp_video_player.data.host
};

var getMeta = function getMeta(params) {
  var dfd = jQuery.Deferred();

  if (params.options.assetId) {
    $.getJSON(params.requestUri).done(function (result) {
      var jsonLDTags = common.getJsonLDString(result);

      if (!jsonLDTags) {
        vars.logger.warn("Failed to create JSON-LD script for video: ".concat(params.options.assetId));
        jsonLDTags = '';
      }

      var thumbnailSrc = common.getThumbnailFromResult(result);

      if (thumbnailSrc) {
        thumbnailSrc += "?w=".concat(params.options.width);
      }

      var elementModel = {
        assetId: params.options.assetId,
        businessUnit: params.options.businessUnit,
        customer: params.options.customer,
        jsonLDTags: jsonLDTags,
        thumbnailSrc: thumbnailSrc
      };
      dfd.resolve(elementModel);
    }).catch(function (error) {
      var message = "CLIENT: ".concat(common.errorMessages.failedWithAssetId, "=").concat(params.options.assetId, ". ");
      message += "Message: ".concat(error.responseText || error.statusText);
      vars.logger.warn(message);
      dfd.reject(error);
    });
  } else {
    vars.logger.warn(common.errorMessages.noAssetId);
    dfd.reject(common.errorMessages.noAssetId);
  }

  return dfd;
};


var loadView = function loadView(node, view, model, action) {
  var templateRoot = svs.components.emp_video_player.templates;

  var addClickEvent = function addClickEvent(node, actionEvent) {
    node.addEventListener('click', function () {
      actionEvent(node);
    });
  };

  if (view === 'thumbnail') {
    var currentNode = node.parentNode;

    if (currentNode) {
      currentNode.innerHTML = templateRoot.thumbnail(model);
      var overlayNode = currentNode.querySelector('.js-emp-partial-overlay');

      var clickAction = function clickAction() {
        action(currentNode, {
          assetId: model.assetId,
          businessUnit: model.businessUnit,
          customer: model.customer
        });
      };

      addClickEvent(overlayNode, clickAction);
    }
  } else if (view === 'missing') {
    node.innerHTML = templateRoot.missing_video({});
  } else {
    node.innerHTML = templateRoot.emp_video_player();
  }
};

svs.components.emp_video_player.helpers.client = {
  getMeta: getMeta,
  loadView: loadView,
  vars: vars
};
 })(window);